import { render, staticRenderFns } from "./tourBus.vue?vue&type=template&id=fec40cae&scoped=true&"
import script from "./tourBus.vue?vue&type=script&lang=js&"
export * from "./tourBus.vue?vue&type=script&lang=js&"
import style0 from "./tourBus.vue?vue&type=style&index=0&id=fec40cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fec40cae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VForm,VSelect,VTextField})
